export const isCompleted = (value: Record<string, boolean>, optionsKeys: string[] = []) => {
  return Object.keys(value).reduce(
    (isCompleted, key) => isCompleted && (value[key] || optionsKeys.includes(key)),
    true,
  );
};
